import React from "react";
import PropTypes from "prop-types";
// import { RadialBarChart, RadialBar, Legend } from "recharts";
import { Progress } from "antd";
import "styles/radial-score.css";

class RadialScore extends React.Component {
    render() {
        const { value, maxBound, render, label } = this.props;
        return (
            <div
                className={
                    "d-flex w-100 flex-column justify-content-center align-items-center pos-rel"
                }
            >
                <Progress
                    type="circle"
                    gapDegree={120}
                    gapPosition={"bottom"}
                    percent={(value / maxBound) * 100}
                    strokeLinecap={"square"}
                    strokeWidth={15}
                    strokeColor={"#246079"}
                    format={
                        render
                            ? perc => render(perc, { value, maxBound })
                            : null
                    }
                    className={"radial-score"}
                />
                {label ? (
                    <div className={"pos-abs b-5 radial-score-label"}>
                        {label}
                    </div>
                ) : null}
            </div>
        );
    }
}

RadialScore.defaultProps = {
    value: 0,
    maxBound: 100,
    label: null
};

RadialScore.propTypes = {
    value: PropTypes.number,
    maxBound: PropTypes.number,
    render: PropTypes.func,
    label: PropTypes.func
};

export default RadialScore;

{
    /* <RadialBarChart
                width={300}
                height={300}
                innerRadius={"10%"}
                outerRadius={"80%"}
                data={[
                    { name: "a", uv: 100, fill: "#fff" },
                    { name: "b", uv: 12, fill: "#87d068" }
                ]}
                startAngle={180}
                endAngle={0}
            >
                <RadialBar
                    minAngle={15}
                    label={{ fill: "#fff", position: "insideStart" }}
                    background
                    clockWise={true}
                    dataKey="uv"
                />
            </RadialBarChart> */
}
